


















import Vue from 'vue';
import Component from 'vue-class-component';
import {Emit, Prop, Watch} from 'vue-property-decorator';
import {GoogleLocationSelected} from '@/utils/map';
import {noop} from 'rxjs';

interface LocationItem {
  text: string;
  value: {
    description: string;
    place_id?: string;
  }
}

@Component({})
export default class GoogleSearch extends Vue {
  valid = false;
  search: string = '';
  sessionId: string = '';
  items: LocationItem[] = [];
  selected: LocationItem | null = null;
  @Prop({required: false}) rules!: [] | null;
  @Prop({required: false, default: true}) outlined!: boolean;
  @Prop({required: true}) label!: string;
  @Prop({required: true}) initialLocation!: GoogleLocationSelected | null;
  @Prop({required: false, default: ''}) filterByCountry!: string;
  @Prop({required: false, default: false}) disabled!: boolean;

  mounted() {
    this.sessionId = `ikone-sd-${Date.now()}`;
  }

  @Watch('search', {immediate: true, deep: true})
  onSearchChange(search?: string) {
    if (!search) {
      return;
    } else if (search.length < 3) {
      return;
    }
    if (this.selected?.text !== search) {
      this.getAutoCompleteItems(search);
    }
  }

  onLocationChange(location: LocationItem) {
    this.getLocationData({place_id: location.value.place_id, description: location.text},)
  }

  @Watch('initialLocation', {immediate: true, deep: true})
  async onInitialLocationChange(newValue?: GoogleLocationSelected) {

    if (!newValue) {
      return;
    }

    try {
      const items = await this.fetchGoogleSearchItems({
        search: newValue.description, latLng: {
          lat: newValue.latitude,
          lng: newValue.longitude,
        },
      });
      if (items) {
        const item = items[0];
        this.selected = {
          text: newValue.description,
          value: {
            place_id: item.place_id,
            description: newValue.description,
          },
        };
        this.items.push(this.selected);
      }
    } catch (e) {
      noop();
    }
  }

  @Emit()
  onSelect(value: GoogleLocationSelected): GoogleLocationSelected {
    return value
  }

  /**
   *
   * Fetch selected location details
   */
  private getLocationData(data: { place_id?: string, location?: { lat: number, lng: number }, description: string }) {
    if (!this.checkGoogleInitialized()) {
      return;
    }
    const {Geocoder} = this.googleApi().maps;
    const geocoder = new Geocoder();
    geocoder.geocode({
      placeId: data.place_id,
    }, (response: any, status: any) => {
      if (response && response[0]) {
        const a = response[0];
        const {location} = a && a.geometry;
        this.onSelect({
          description: data.description,
          latitude: location.lat(),
          longitude: location.lng(),
        });
      }
    });
  }

  /**
   *
   * Fetch all items to populate autocomplete
   */
  private async getAutoCompleteItems(search: string) {
    try {
      const items = await this.fetchGoogleSearchItems({search});
      if (items) {
        this.items = items.map((v) => {
          return {
            text: v.description,
            value: {
              place_id: v.place_id,
              description: v.description,
            },
          }
        })
      }
    } catch (e) {
      noop();
    }
  }

  /**
   * Make Google Request
   */
  private fetchGoogleSearchItems(data: { search?: string, latLng?: { lat: number, lng: number } }): Promise<any[]> {
    return new Promise((resolve, reject) => {
      if (this.checkGoogleInitialized()) {
        const {AutocompleteService} = this.googleApi().maps.places;
        const {LatLng} = this.googleApi().maps;
        const autocompleteService = new AutocompleteService();
        let location = null;

        if (data.latLng) {
          location = new LatLng(Number(data.latLng.lat), Number(data.latLng.lng))
        }
        autocompleteService.getPlacePredictions({
          input: data.search,
          componentRestrictions: {country: this.filterByCountry},
          sessiontoken: this.sessionId,
        }, (result: any[]) => {
          if (result) {
            resolve(result)
          }
        })
      }
    });
  }

  private checkGoogleInitialized(): boolean {
    return (this.googleApi() !== undefined)
  }

  private googleApi() {
    // @ts-ignore
    return window.google
  }
}

